import { Flex, LicencePlate, smBumps } from '@wrisk/ui-components'
import { default as React, FunctionComponent } from 'react'

import { toVehicleDescription } from '../../../domain'
import { tDefaults } from '../../../infrastructure/internationalisation'
import { VehicleInputValue } from '../inputs'
import { Formatter } from '../types'

export const VehicleFormatter: FunctionComponent<Formatter<VehicleInputValue>> = ({
  value,
  size,
  t,
}) =>
  value?.specification ? (
    <Flex columnGap={smBumps} justifyContent='flex-start'>
      {value?.vrn && size !== 'small' && (
        <LicencePlate licencePlate={value.vrn} size='small' />
      )}
      <span>{toVehicleDescription(value.specification)}</span>
    </Flex>
  ) : (
    <>{t(tDefaults('inputs.no-answer'))}</>
  )
